import AppHeader from '../AppHeader'
import DayJs from 'dayjs'

export default {
  name: 'stepup-new',
  created () {
    this.getShop()
    this.getQuestions()
  },
  data () {
    return {
      shopId: '',
      userId: '',
      joinRestrictionDate: '',
      shopRestrictionDate: '',
      notificationStartDate: '',
      answerStartDate: '',
      endDate: '',
      questionIds: [],
      ownQuestionId: '',
      canValidate: true,
      shopGetCallbackFlag: false,
      getQuestionEndFlag: false,
      users: '',
      questions: '',
      savingFlag: false,
      futureShopChangeExist: false,
      futureUsertypeChangeExist: false
    }
  },
  watch: {
    shopId (val) {
      this.userId = ''
      if (val) {
        this.getUser(val)
      } else {
        this.users = ''
      }
    }
  },
  computed: {
    shops () {
      return this.$store.getters.shopsAll
    },
    joinRestrictionDateFormat () {
      return DayJs(this.joinRestrictionDate).format('YYYY-MM-DD')
    },
    shopRestrictionDateFormat () {
      return DayJs(this.shopRestrictionDate).format('YYYY-MM-DD')
    },
    notificationStartDateFormat () {
      return DayJs(this.notificationStartDate).format('YYYY-MM-DD')
    },
    answerStartDateFormat () {
      return DayJs(this.answerStartDate).format('YYYY-MM-DD')
    },
    endDateFormat () {
      return DayJs(this.endDate).format('YYYY-MM-DD')
    },
    validation: function () {
      let today = DayJs(new Date()).format('YYYY-MM-DD')
      var v = {
        shopId: !!this.shopId,
        userId: !!this.userId,
        joinRestrictionDate: !!this.joinRestrictionDate,
        shopRestrictionDate: !!this.shopRestrictionDate,
        notificationStartDate: !!this.notificationStartDate,
        notificationStartDateRange: DayJs(today).isBefore(this.notificationStartDateFormat),
        answerStartDate: !!this.answerStartDate,
        answerStartDateRange: this.notificationStartDateFormat < this.answerStartDateFormat,
        endDate: !!this.endDate,
        endDateRange: this.answerStartDateFormat < this.endDateFormat,
        questionIds: this.questionIds.length > 0,
        ownQuestionId: !!this.ownQuestionId,
        futureShopChangeExist: !this.futureShopChangeExist,
        futureUsertypeChangeExist: !this.futureUsertypeChangeExist,
        notInput: !!this.shopId &&
        !!this.userId &&
        !!this.joinRestrictionDate &&
        !!this.shopRestrictionDate &&
        !!this.notificationStartDate &&
        DayJs(today).isBefore(this.notificationStartDateFormat) &&
        !!this.answerStartDate &&
        this.notificationStartDateFormat < this.answerStartDateFormat &&
        !!this.endDate &&
        this.answerStartDateFormat < this.endDateFormat &&
        this.questionIds.length > 0 &&
        !!this.ownQuestionId &&
        !this.futureShopChangeExist &&
        !this.futureUsertypeChangeExist
      }
      if (!this.canValidate) {
        Object.keys(v).forEach(key => { v[key] = true })
      }
      return v
    },
    isValid () {
      var validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    }
  },
  components: {
    AppHeader
  },
  methods: {
    getShop: function () {
      const self = this
      const callback = function () {
        self.shopGetCallbackFlag = true
        // 退職者一覧店舗を表示しない
        let workIndex = 0
        for (let i = 0; i < self.shops.length; i++) {
          if (self.shops[i].id == 800) {
            workIndex = i
            break
          }
        }
        if (workIndex !== 0) {
          self.shops.splice(workIndex, 1)
        }
      }

      this.$store.dispatch('SHOP_ALL_GET', {callback: callback})
    },
    async getQuestions () {
      let data = {}
      let res = await this.$store.dispatch('GET_QUESTION_ALL', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
      this.questions = res.questions
      for (let i = 0; i < this.questions.length; i++) {
        this.questionIds.push(this.questions[i].id)
      }
      this.getQuestionEndFlag = true
    },
    async getUser (shopId) {
      let res = ''
      res = await this.$store.dispatch('USER_GET_BY_SHOP', {
        data: {
          shop_id: shopId
        }
      })
      .catch(err => {
        console.log(err)
      })
      this.users = res.users
    },
    onChangeNotificationStartDate: function () {
      if (this.notificationStartDate) {
        this.joinRestrictionDate = DayJs(this.notificationStartDateFormat).subtract(2, 'month')
        this.shopRestrictionDate = DayJs(this.notificationStartDateFormat).subtract(1, 'month')
      } else {
        this.joinRestrictionDate = ''
        this.shopRestrictionDate = ''
      }
    },
    async onClickSave () {
      if (this.savingFlag) return false
      this.savingFlag = true
      await this.$store.dispatch('STEPUP_CREATE', {
        data: {
          shop_id: this.shopId,
          user_id: this.userId,
          join_restriction_date: this.joinRestrictionDateFormat,
          shop_restriction_date: this.shopRestrictionDateFormat,
          notification_start_date: this.notificationStartDateFormat,
          answer_start_date: this.answerStartDateFormat,
          end_date: this.endDateFormat,
          question_ids: this.questionIds,
          own_question_id: this.ownQuestionId
        }
      })
      .catch(err => {
        console.log(err)
        return
      })

      this.$router.push('/stepup_list')
    },
    futureChangeCheck (userId) {
      this.futureShopChangeCheck(userId)
      this.futureUsertypeChangeCheck(userId)
    },
    async futureShopChangeCheck(userId) {
      let res = await this.$store.dispatch('STEPUP_FUTURE_SHOP_CHANGE_CHECK', {
        data: {
          user_id: userId
        }
      })
      .catch(err => {
        console.log(err)
        return
      })
      this.futureShopChangeExist = res.exist
    },
    async futureUsertypeChangeCheck(userId) {
      let res = await this.$store.dispatch('STEPUP_FUTURE_USERTYPE_CHANGE_CHECK', {
        data: {
          user_id: userId
        }
      })
      .catch(err => {
        console.log(err)
        return
      })
      this.futureUsertypeChangeExist = res.exist
    },
    onClickCancel: function () {
      this.$router.push('/stepup_list')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/stepup-new.js